<template>
  <div class="content-wrapper">
    <h1>{{ getTitle }}</h1>
    <template v-if="linkbuilding != null">
      <template v-if="linkbuilding.adminData.copyscapeScore == '0'">
        <div class="copyscape">
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path fill="#4adb91" d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
          <span>Copyscape passed</span>
        </div>
      </template>
      <template v-else>
        <a href="https://www.copyscape.com/login.php" target="_blank" class="copyscape">
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0z" fill="none"/><path fill="#de7d7d" d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
          <span>Copyscape failed - test manually</span>
        </a>
      </template>

      <LinkBuilding :linkbuilding="linkbuilding.userData" :adminData="linkbuilding.adminData"></LinkBuilding>

      <div>
        <a :href="'https://europe-west1-freelance-ffddb.cloudfunctions.net/generate-word-doc?id=' + $route.params.id" target="_blank">Download Word Doc</a>
      </div>

      <div class="button-container" v-if="linkbuilding.adminData.status == 'Revision Needed'">
        <button class="button button--thin" data-cy="review-button" @click="updateLinkBuilding(linkbuilding, 'Pending Review', 'change back to pending review')">Pending review</button>
      </div>
      <div class="button-container" v-if="linkbuilding.adminData.status == 'Pending Review'">
        <button class="button button--thin button--danger" data-cy="revision-button" @click="modalOpen = true">Needs revision</button>
        <button class="button button--thin button--margin-left" data-cy="approve-button" @click="updateLinkBuilding(linkbuilding, 'Approved', 'approve this article')">Approve</button>
      </div>
      <div class="button-container" v-if="linkbuilding.adminData.status == 'Approved'">
        <button class="button button--thin button--danger" data-cy="revision-button" @click="modalOpen = true">Needs revision</button>
        <button class="button button--thin button--margin-left" @click="updateLinkBuilding(linkbuilding, 'Exported', 'mark this article as exported')">Mark as exported</button>
      </div>
      <div class="button-container" v-if="linkbuilding.adminData.status == 'Exported'">
        <button class="button button--thin button--danger" @click="updateLinkBuilding(linkbuilding, 'Approved', 'change back to approved')">Change back to Approved</button>
      </div>
      <RevisionEmail
        v-if="modalOpen"
        :email="emailData"
        :submittedBy="linkbuilding.adminData.submittedBy"
        :type="'linkbuilding'"
        :taskStatus="'Pending Review'"
        :linkbuilding="linkbuilding"
        v-on:update:modalOpen="modalOpen = $event"
      ></RevisionEmail>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase'
import LinkBuilding from '@/components/linkbuilding'
import RevisionEmail from '@/components/revisionemail'
import emailApi from '@/services/email'

export default {
  name: 'id',
  data() {
    return {
      linkbuilding: null,
      isFetching: true,
      modalOpen: false,
      emailData: {
        subject: 'Your LinkBuilding article needs revision',
        recipients: [],
        body: '',
      },
    }
  },
  methods: {
    getLinkBuildingData() {
      this.content = JSON.parse(JSON.stringify(this.$store.getters.content))
      var _this = this
      var docRef = firebase
        .firestore()
        .collection('linkbuilding')
        .doc(this.$route.params.id)
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            _this.linkbuilding = doc.data()
          } else {
            console.log('No such document!')
          }
        })
        .catch(function(error) {
          console.log('Error getting document:', error)
        })
        .then(function() {
          _this.isFetching = false
        })
    },
    updateLinkBuilding(linkbuilding, status, message) {
      var _this = this

      this.$dialog
        .confirm('Are you sure you want to ' + message + '?')
        .then(function() {
          var u = _this.$store.getters['user']

          linkbuilding.userData.status = status
          linkbuilding.adminData.status = status

          var batch = firebase.firestore().batch()
          var userContentRef = firebase
            .firestore()
            .collection('users')
            .doc(linkbuilding.adminData.submittedBy)
            .collection('linkbuilding')
            .doc(linkbuilding.adminData.linkbuildingId)
          batch.set(userContentRef, linkbuilding.userData)

          linkbuilding.adminData.reviewedAt = new Date().toISOString()
          linkbuilding.adminData.reviewedBy = u.data.uid
          var contentRef = firebase
            .firestore()
            .collection('linkbuilding')
            .doc(_this.$route.params.id)
          batch.set(contentRef, linkbuilding)

          batch
            .commit()
            .then(function() {
              console.log('Transaction successfully committed!')
              _this.$notify({
                text: 'Successfully updated linkbuilding status',
                type: 'success',
              })
              _this.modalOpen = false
            })
            .catch(function(error) {
              console.log('Transaction failed: ', error)
              _this.$notify({
                text: 'Failed to update linkbuilding status',
                type: 'error',
              })
            })
        })
        .catch(function(error) {
          console.log('Transaction failed: ', error)
          console.log('Clicked cancel on dialog')
        })
    },
  },
  mounted: function() {
    this.getLinkBuildingData()
  },
  computed: {
    getTitle() {
      if (this.linkbuilding === null) {
        return 'Fetching LinkBuilding Data'
      }
      return this.linkbuilding.adminData.status
    },
  },
  components: {
    LinkBuilding,
    RevisionEmail,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.button-container {
  display: flex;
  margin-left: auto;
}
</style>
